import React from 'react';
import styled from 'styled-components';
import TitleDiv from './titleDiv.jsx';

const ImageGrid = ({ images, startIndex, openPanel }) => {
  const displayedImages = images.slice(0, 2);
  const isTwoImages = displayedImages.length === 2;
  const isVerticalLayout = isTwoImages && window.innerHeight > window.innerWidth;

  // 클릭 이벤트 핸들러: 내용과 아이콘을 토글합니다.
  const handleClick = (title) => {
    
    if (openPanel(title) === false) {
      //setIsTitle(!isTitle);
      //setIcon(icon === faExpand ? faCompress : faExpand);
    }
  };

    
  return (
    <Container>
      <Row isVerticalLayout={isVerticalLayout} isTwoImages={isTwoImages}>
        {displayedImages.slice(0, 2).map((item, index) => (
          <ImageContainer key={index}  onClick={()=>handleClick(item.title)}>
            <Image src={item.src} alt={`image-${startIndex + index}`} />
            <TitleDiv title={item.title} desc={item.desc} openPanel={openPanel} selectable={true} />
          </ImageContainer>
        ))}
      </Row>
      {displayedImages.length > 2 && (
        <Row isVerticalLayout={isVerticalLayout}>
          {displayedImages.slice(2, 4).map((item, index) => (
            <ImageContainer key={index} onClick={()=>handleClick(item.title)}>
              <Image src={item.src} alt={`image-${startIndex + 2 + index}`} />
              <TitleDiv title={item.title} desc={item.desc} openPanel={openPanel} selectable={true} />
            </ImageContainer>
          ))}
        </Row>
      )}
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const Row = styled.div`
  display: flex;
  height: ${({ isTwoImages }) => (isTwoImages ? '100%' : '50%')};
  ${({ isVerticalLayout }) => isVerticalLayout && `
    flex-direction: column;
    height: 100%;
  `}
`;

const ImageContainer = styled.div`
  flex: 1;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export default ImageGrid;
